import React from "react";
import type {VoidFunctionComponent} from "react";
// Because this component has a nested FontIcon instance that must be styled differently based on where it is used,
// this component does not use CSS modules.
import "./FavoriteToggle.scss";
import {FontIcon} from "../../common/FontIcon";

export interface IFavoriteToggle {
  isFavorited?: boolean;
  onChangeHandler: () => void;
}

export const FavoriteToggle: VoidFunctionComponent<IFavoriteToggle> = ({isFavorited, onChangeHandler}) => {
  const faveToggleLabel = (isFavorited ? "Mark as not a favorite" : "Mark as a favorite");
  return (
    <div className={`faveToggle`}>
      <input type="checkbox"
        checked={isFavorited}
        aria-label={faveToggleLabel}
        title={faveToggleLabel}
        onChange={onChangeHandler}
      />
      <FontIcon icon={isFavorited ? "icon-favorite-solid" : "icon-favorite"} />
    </div>
  );
}
